module.exports = __webpack_public_path__ + "static/media/bed-white.66ae7092.svg";